import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { Field } from "formik";
import { CSS } from "@dnd-kit/utilities";
import { findPathsToValue } from "../../GetPath";
import { useLanguage } from "../../languageContext";
import translations from "../../translation.json";
import { GripVertical } from "lucide-react";

function VerticalSortableColumns({
  column,
  setValues,
  isDarkMode,
  values,
  index,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.id });

  const { language } = useLanguage();

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    borderBottom: isDarkMode ? "1px solid #495057" : "1px solid #dee2e6",
  };

  const FindPath = (content, language) => {
    const fullPath = findPathsToValue(translations, content)?.[0];
    if (!fullPath) return content;

    const trimmedPathArray = fullPath.split('.').slice(0, -1);
    const basePath = trimmedPathArray.join('.');

    const translation = basePath
      .split('.')
      .reduce((obj, key) => (obj && obj[key] ? obj[key] : undefined), translations);

    const result = translation ? translation[language] : undefined;
    return result || content;
  };

  return (
    <div
      className="col-12 d-flex align-items-center justify-content-between px-3 py-2"
      style={{ ...style }}
    >
      <div className="d-flex align-items-center gap-2">
        <span
          ref={setNodeRef}
          {...attributes}
          {...listeners}
          title="Drag to reorder"
          style={{
            display: "flex",
            alignItems: "center",
            color: "#888",
            cursor: "grab",
          }}
        >
          <GripVertical size={16} />
        </span>

        <label htmlFor={`inputadddealership-${column.id}`} className="form-label m-0">
          {FindPath(column.content, language)}
        </label>
      </div>

      <div>
        <Field
          type="checkbox"
          className="form-check-input"
          checked={values.columns[index]?.renderInView ?? false}
          id={`inputadddealership-${column.id}`}
          style={{
            border: isDarkMode ? "1px solid #495057" : "1px solid #dee2e6",
          }}
          onChange={(e) => {
            const updatedColumns = values.columns.map((col, idx) =>
              idx === index ? { ...col, renderInView: e.target.checked } : col
            );

            setValues({
              ...values,
              columns: updatedColumns,
            });
          }}
        />
      </div>
    </div>
  );
}

export default VerticalSortableColumns;
